// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e5a1a579","455":"9bff8ff7"}[chunkId] + ".chunk.js";
};